<template>
  <div class="edit__lab_test_form">
    <div class="product_list__table" v-if="lab_test">
      <!-- lab test product details -->
      <vs-table :data="lab_test.labTestInventory" class="vs-con-loading__container mt-8 border border-solid">
        <template slot="thead">
          <vs-th>Item Name</vs-th>
          <vs-th>Price</vs-th>
          <vs-th>Quantity</vs-th>
          <vs-th>SubTotal</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.product_name }}</vs-td>

            <vs-td>{{ tr.unit_price | currencyFilter }}</vs-td>

            <vs-td>
              <vs-input
                type="number"
                :value="tr.quantity"
                :min="0"
                :max-decimal="1"
                @change="e => updateLabTestProducts({ key: 'id', value: tr.id, field: 'quantity', data: e.target.value | weightFilter })"
                class="inputx"
              />
            </vs-td>

            <vs-td>{{ renderSubTotal(tr) | currencyFilter }}</vs-td>
          </vs-tr>

          <vs-tr>
            <vs-td colspan="3"></vs-td>
            <vs-td> Total - {{ calculateTotal | currencyFilter }} </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="px-5 grid grid-cols-1 gap-10 sm:grid-cols-2 mt-8">
        <div class="col-lg-6">
          <label class="mega-option">
            <span class="option-control">
              <span class="radio">
                <input type="radio" class="mr-2" v-model="pickUpType" value="express_pickup" name="PickupType" checked="checked" />
                <span></span>
              </span>
            </span>
            <span class="option-label">
              <span class="option-body">I will deliver the sample to Express Toxicology. x1717 W 213 E Main 33rd St., Street, Ada Edmond, OK 74820</span>
            </span>
          </label>
        </div>

        <div class="col-lg-6">
          <label class="mega-option">
            <span class="option-control">
              <span class="radio">
                <input type="radio" class="mr-2" v-model="pickUpType" value="pickup" name="PickupType" />
                <span></span>
              </span>
            </span>
            <span class="option-label">
              <span class="option-body"
                >I would like Express Toxicology to pick up the sample(s). Orders under $2000 will have a pick up charge of $199. Orders over $2000 will have a pick up charge of $99.</span
              >
            </span>
          </label>
        </div>
      </div>

      <div class="update_btn mt-4 text-right">
        <vs-button color="success" type="filled" @click="updateLabTest">Update</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { weightMixins } from '@/utils/weightType'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'EditLabTest',

  data() {
    return {
      pickUpType: 'express_pickup'
    }
  },

  mixins: [weightMixins, paymentMixins],

  computed: {
    ...mapState('lab_test', ['lab_test']),

    renderSubTotal() {
      return item => {
        return item.unit_price * Number(item.quantity)
      }
    },

    calculateTotal() {
      return this.lab_test.labTestInventory.reduce((acc, item) => {
        const tempTotal = item.unit_price * Number(item.quantity)
        return acc + paymentMixins.methods.mathRound(tempTotal, 2)
      }, 0)
    }
  },

  methods: {
    ...mapMutations('lab_test', { updateLabTestProducts: 'UPDATE_LAB_TEST_ITEMS' }),
    ...mapActions('lab_test', { update_lab_test: 'updateLabTest' }),

    // update lab status
    async updateLabTest() {
      const requestObj = {}

      // test products
      const labProducts = []
      this.lab_test.labTestInventory.forEach(element => {
        const tempProduct = {}

        tempProduct.labProductId = element.labProductId
        tempProduct.product_name = element.product_name
        tempProduct.quantity = weightMixins.methods.mathRound(element.quantity, 3)
        tempProduct.unit_price = paymentMixins.methods.mathRound(element.unit_price, 2)
        tempProduct.sub_total = paymentMixins.methods.mathRound(element.unit_price * Number(element.quantity), 2)

        labProducts.push(tempProduct)
      })

      requestObj.labProducts = labProducts

      // total
      requestObj.total = paymentMixins.methods.mathRound(this.calculateTotal, 2)

      requestObj.pickUpType = this.pickUpType

      try {
        const { message } = await this.update_lab_test({ id: this.$route.params.id, data: requestObj })

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },

  // filters
  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  }
}
</script>

<style></style>
